import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../../../nodeIds';

export const leukemia: AnswerPathTreeNode = {
  path: 'leukemia',
  children: [{ path: 'details', nodeId: NodeIds.healthInsuredLeukemiaDetails }],
};
